export default __webpack_public_path__ + "static/media/03-banner-XXFORO.c04b8bc7.jpg";